/**
 * User-related models
 */

/**
 * User DTO (Response)
 * Maps from ApplicationUser entity.
 * Note: PasswordHash is intentionally excluded for security.
 * Note: IsSystemAdmin is NOT in UserDto - it's returned separately in LoginResponse and InitResponse.
 * IsSystemAdmin can be computed from userScope === 1 (UserScope.System)
 */
export interface UserDto {
  id: string;
  firstName: string;
  lastName: string;
  /** Display name: firstName + lastName (for backward compatibility) */
  name: string;
  email: string;
  staffRole?: number | null; // Display only, not for authorization
  jobTitle?: string | null;
  accountType?: number | null;
  companyName?: string | null;
  twoFactorEnabled: boolean;
  lastLogin?: string | null;
  isActive: boolean;
  userScope: number | string; // 1 | 2 | 3 or "System" | "Marina" | "Client"
  requiresTwoFactor?: boolean; // Whether 2FA is required for this user (default: true)
  createdAt: string;
  updatedAt: string;
}

/**
 * Update User Request
 */
export interface UpdateUserRequest {
  firstName?: string;
  lastName?: string;
  email?: string;
  userScope?: number; // 1 = System, 2 = Marina, 3 = Client
  isActive?: boolean;
  requiresTwoFactor?: boolean;
}